import { MutedAlertCameras, MutedAlertSites } from "./alertsInterfaces";

export const checkSelectedRowForMuting = (
  selectedRow: any,
  mutedAlertSites: MutedAlertSites,
  mutedAlertCameras: MutedAlertCameras,
  setSelectedRowIsMuted: (selectedRowIsMuted: boolean) => void
) => {
  // Early return if selectedRow is invalid or empty
  if (!selectedRow) {
    setSelectedRowIsMuted(false);
    return;
  }

  let isMuted = false;

  mutedAlertSites.forEach((mutedSite) => {
    if (mutedSite.site_id === selectedRow.customer_pk) {
      isMuted = true;
    }
  });

  mutedAlertCameras.forEach((mutedCamera) => {
    if (mutedCamera.camera_id === selectedRow.camera_pk) {
      isMuted = true;
    }
  });

  setSelectedRowIsMuted(isMuted);
};
